// extracted by mini-css-extract-plugin
module.exports = {"countDown":"styles_countDown__BnETB","group":"styles_group__11KtI","number":"styles_number__3jC-e","separator":"styles_separator__1hvLY"};